import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import ArtifactHealthApplicationsComponent
  from './../Components/ArtifactHealthApplicationsComponent.jsx';
import { getArtifactHealthPlatform } from './../reducers';
import { modal as modalActions } from './../actions';
import { annotation as annotationSelectors } from './../selectors';

export const mapStateToProps = (state, ownProps) => {
  const platform = getArtifactHealthPlatform(state, ownProps.platform);
  const annotations = annotationSelectors.getAnnotationsByAppIdsOrderByDate(state);
  const props = {
    appStatuses: platform ? platform.statuses : [],
    annotations: annotations
  };
  return props;
};

export const mapDispatchToProps = (dispatch) => {
  return {
    showCommentHistory: (app) => {
      dispatch(modalActions.showCommentHistory(true, app));
    },
  };
};

const ArtifactHealthApplicationsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactHealthApplicationsComponent);

ArtifactHealthApplicationsContainer.propTypes = { platform: PropTypes.string.isRequired };

export default ArtifactHealthApplicationsContainer;


// WEBPACK FOOTER //
// src/Containers/ArtifactHealthApplicationsContainer.jsx